export const flatOptions = [
  "1+kk",
  "1+1",
  "2+kk",
  "2+1",
  "3+kk",
  "3+1",
  "4+kk",
  "4+1",
  "5+kk",
  "5+1",
  "6 a více",
  "Atypický",
  "Pokoj",
];

export const homeOptions = [
  "Chata",
  "Památka/jiné",
  "Rodinný",
  "Vila",
  "Na klíč",
  "Chalupa",
  "Zemědělská usedlost",
  "Vícegenerační dům",
];

export const landOptions = [
  "Komerční",
  "Bydlení",
  "Pole",
  "Lesy",
  "Louky",
  "Zahrady",
  "Ostatní",
  "Rybníky",
  "Sady/vinice",
];

export const comercialOptions = [
  "Kanceláře",
  "Sklady",
  "Výroba",
  "Obchodní prostory",
  "Ubytování",
  "Restaurace",
  "Zemědělský",
  "Ostatní",
  "Činžovní dům",
  "Virtuální kancelář",
  "Ordinace",
  "Apartmány",
];

export const otherOptions = [
  "Garáž",
  "Ostatní",
  "Vinný sklep",
  "Půdní prostor",
  "Garážové stání",
  "Mobilheim",
];

export const ownershipOptions = [
  "Osobní",
  "Družstevní",
  "Státní/obecní",
  "Podíly",
];
export const estateConditionOptions = [
  "Velmi dobrý",
  "Dobrý",
  "Špatný",
  "Ve výstavbě",
  "Projekt",
  "Novostavba",
  "K demolici",
  "Před rekonstrukcí",
  "Po rekonstrukci",
  "V rekonstrukci",
];

export const accessoriesOptions = [
  "Balkon",
  "Lodžie",
  "Zahrada",
  "Terasa",
  "Sklep",
  "Parkování",
  "Garáž",
  "Bezbariérový",
  "Výtah",
];
